import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ds-card-media',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="ds-card-media"
      [style.aspect-ratio]="ratio()"
    >
      <span class="ds-card-media__label">{{ label() || 'visuel' }}</span>
    </div>
  `,
  styles: [`
    .ds-card-media {
      background: repeating-linear-gradient(
        135deg,
        #F8EFEA,
        #F8EFEA 8px,
        #EFE3DC 8px,
        #EFE3DC 16px
      );
      border-radius: 6px;
      margin-bottom: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ds-card-media__label {
      font-family: var(--f-mono);
      font-size: 11px;
      color: #866B5A;
      letter-spacing: 0.04em;
      text-transform: uppercase;
    }
  `],
})
export class DsCardMediaComponent {
  readonly ratio = input<string>('16 / 9');
  readonly label = input<string>('');
}
